<template>
  <div class="AnnouncementList primary-scroll">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AnnouncementList',
  props: {
    variant: {
      type: String,
      default: 'purple',
      validator(value) {
        return ['purple', 'green', 'orange'].includes(value)
      },
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss">
.AnnouncementList {
  display: grid;
  gap: 16px;
  align-items: center;
  grid-auto-flow: column;
  margin: 0 -16px;
  padding: 32px 16px 0 16px;
  overflow-x: auto;
  grid-template-columns: repeat(1, 1fr);

  &:empty {
    padding: 0;
  }

  & > * {
    width: calc(100vw - 36px);
  }

  @include media(sm) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-flow: row;
    & > * {
      width: auto; /* Items take up 90% of the container width */
    }
  }
  @include media(lg) {
    grid-template-columns: repeat(3, 1fr);
    grid-auto-flow: row;
  }

  @include media(xl) {
    grid-template-columns: repeat(4, 1fr);
    grid-auto-flow: row;
  }
}
</style>
